import React, { ReactNode } from 'react'
import 'app/styles/components/notes.css'

interface Props {
    children: ReactNode
}

export default function NotesBody({ children } : Props) {
    
    return (
        <div className='notes-body'>
           {children}
        </div>
    )
}
